import { render, staticRenderFns } from "./VorlagePromotionsstruktur.vue?vue&type=template&id=461ab92f&"
import script from "./VorlagePromotionsstruktur.vue?vue&type=script&lang=js&"
export * from "./VorlagePromotionsstruktur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports